import { cloneDeep } from 'lodash'
import LifePage from '@/views/newPension/pensionCard/lifeProduct/index.vue' // 年金
import AnnuityProduct from '@/views/newPension/pensionCard/annuityProduct/index.vue'// 寿险
import InvestPro from '@/views/newPension/pensionCard/investCard/index.vue' // 投资产品

// 步骤三 tab栏 显示的组件
export const propsalTabsListClone = cloneDeep([
  {
    type: 'annuity',
    page: AnnuityProduct,
    name: '年金保险',
    typeName: '年金保险产品选择'
  },
  {
    type: 'life',
    page: LifePage,
    name: '增额终身寿保险',
    typeName: '增额终身寿险产品选择'
  },
  {
    type: 'investCard',
    page: InvestPro,
    rightTabBtnAlias: '新增投资组合',
    name: '投资产品',
    typeName: '投资产品选择'
  },
])

/**
 * pageRuleSort 页面规则排序
 *
 */
export const pageRuleSortList = [
  {
    name: '养老规划封面',
    page: 'cover',
    id: '',
    status: false
  },
  // {
  //   name: '养老目标确认',
  //   page: 'target',
  //   id: '',
  //   status: false
  // },
  // {
  //   name: '养老需求测算',
  //   page: 'demand',
  //   id: '',
  //   status: false
  // },
  // {
  //   name: '养老供给测算',
  //   page: 'supply',
  //   id: '',
  //   status: false
  // },
  {
    name: '空白页面',
    page: 'empty',
    id: '',
    status: true
  }
]

export const genderList = [
  {
    name: '男',
    type: 0
  },
  {
    name: '女',
    type: 1
  }
]

/**
 * Self("本人", 0),
 Mate("配偶", 1),
 Parent("父母", 2),
 Child("子女", 3),
 Branches("兄弟姐妹", 4)
 */

export const memberList = [
  {
    name: '本人',
    type: 'Self'
  },
  {
    name: '配偶',
    type: 'Mate'
  },
  {
    name: '父母',
    type: 'Parent'
  },
  {
    name: '子女',
    type: 'Child'
  },
  {
    name: '兄弟姐妹',
    type: 'Branches'
  }
]
